export default "__VITE_ASSET__rID31Yij__"